import React from 'react'

const Footer = () => {
// A Function to get full getFullYear
  const date=()=>{
    const date= new Date()
    return date.getFullYear()
  }
  date()

  return (
    <div className='bg-blue-700 py-2'>
        <p className='text-white text-center'>Portfolio website@AbdulRehman {date()}.</p>
    </div>
  )
}

export default Footer